import { Link } from "@tanstack/react-router";
import { Phone, Calculator } from "lucide-react";
import { useEffect, useState } from "react";
import { SITE } from "@/lib/site";

export function MobileStickyCTA() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const ids = ["hero-quote-form", "bottom-quote-form"];
    const elements = ids
      .map((id) => document.getElementById(id))
      .filter((el): el is HTMLElement => el !== null);

    if (elements.length === 0) return;

    const visibility = new Map<Element, boolean>();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => visibility.set(entry.target, entry.isIntersecting));
        setHidden(Array.from(visibility.values()).some(Boolean));
      },
      { threshold: 0.15 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 gap-px border-t border-border bg-jet transition-transform duration-300 lg:hidden ${
        hidden ? "translate-y-full pointer-events-none" : "translate-y-0"
      }`}
      aria-hidden={hidden}
    >
      <a
        href={SITE.phoneHref}
        className="flex items-center justify-center gap-2 bg-charcoal py-4 text-sm font-bold uppercase tracking-wider text-silver-light"
      >
        <Phone className="h-4 w-4 text-copper" /> Call Now
      </a>
      <Link
        to="/quote"
        className="flex items-center justify-center gap-2 bg-copper py-4 text-sm font-bold uppercase tracking-wider text-white"
      >
        <Calculator className="h-4 w-4" /> Free Quote
      </Link>
    </div>
  );
}
